import lzString from 'lz-string';
import NavLink from '@/components/common/NavLink';
import VClamp from 'vue-clamp';
import stripHtml from 'string-strip-html';
import AutoLinker from 'autolinker';
import ScrollStop from '../libs/scroll-stop';
import eventBus from './event-bus';
import numeral from 'numeral';
import CONST from '@/constants';

Date.prototype.tz = function(f) {
	return new Date(this.getTime() + 1000 * 60 * 60 * f);
};
Date.prototype.addDays = function(n) {
	return new Date(this.getTime() + 1000 * 60 * 60 * 24 * n);
};
Date.prototype.format = function(f) {
	if (!this.valueOf()) return ' ';
	var weekName = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
	var weekShortName = ['일', '월', '화', '수', '목', '금', '토'];
	var d = this,
		h;
	return f.replace(/(yyyy|yy|MM|dd|E|hh|mm|ss|a\/p)/gi, function($1) {
		switch ($1) {
			case 'yyyy':
				return d.getFullYear();
			case 'yy':
				return (d.getFullYear() % 1000).zf(2);
			case 'MM':
				return (d.getMonth() + 1).zf(2);
			case 'dd':
				return d.getDate().zf(2);
			case 'E':
				return weekName[d.getDay()];
			case 'e':
				return weekShortName[d.getDay()];
			case 'HH':
				return d.getHours().zf(2);
			case 'hh':
				//eslint-disable-next-line no-cond-assign
				return ((h = d.getHours() % 12) ? h : 12).zf(2);
			case 'mm':
				return d.getMinutes().zf(2);
			case 'ss':
				return d.getSeconds().zf(2);
			case 'a/p':
				return d.getHours() < 12 ? 'AM' : 'PM';
			default:
				return $1;
		}
	});
};
String.prototype.string = function(len) {
	var s = '',
		i = 0;
	while (i++ < len) {
		s += this;
	}
	return s;
};
String.prototype.cutBySpace = function(maxSize) {
	var mSize = maxSize || 12;
	if (mSize >= this.length || this.indexOf(' ') < 0) return this.substr(0, mSize);
	var s = this;
	while (s.lastIndexOf(' ') > mSize || s.length > mSize) {
		s = s.substr(0, s.lastIndexOf(' '));
	}
	return s;
};
if (!String.prototype.includes) {
	String.prototype.includes = function(str) {
		return this.indexOf(str) !== -1;
	};
}
String.prototype.zf = function(len) {
	return '0'.string(len - this.length) + this;
};
String.prototype.trim = function() {
	return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
String.prototype.ltrim = function() {
	return this.replace(/^\s+/, '');
};
String.prototype.rtrim = function() {
	return this.replace(/\s+$/, '');
};
String.prototype.onlyNumber = function() {
	//return this.replace( /^\d+$/, "" );
	return this.replace(/[^0-9]/g, '');
};
String.prototype.cut = function(n, delimeter) {
	return this.length > n ? this.substr(0, n) + delimeter : this;
};
String.prototype.cutByByte = function(n, delimeter) {
	var b, i, c;
	//eslint-disable-next-line no-cond-assign
	for (b = i = 0; (c = this.charCodeAt(i)); ) {
		b += c >> 7 ? 2 : 1;
		if (b > n) break;
		i++;
	}
	return this.substring(0, i) + delimeter;
};
Number.prototype.zf = function(len) {
	return this.toString().zf(len);
};
Number.prototype.format = function() {
	if (this === 0) return 0;
	var reg = /(^[+-]?\d+)(\d{3})/;
	var n = this + '';
	while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');
	return n;
};
String.prototype.format = function() {
	var num = parseFloat(this);
	if (isNaN(num)) return '0';
	return num.format();
};
Array.prototype.insert = function(index, item) {
	this.splice(index, 0, item);
};
Array.prototype.remove = function(index) {
	this.splice(index, 1);
};
export default {
	install(Vue) {
		//let loadDataCollbackStack = [];
		Vue.directive('ScrollStop', ScrollStop);
		Vue.component('NavLink', NavLink);
		Vue.component('VClamp', VClamp);
		Vue.component('RenderString', {
			props: ['text'],
			data() {
				return {
					templateRender: null,
				};
			},
			render(h) {
				if (!this.templateRender) {
					return h('div', 'loading...');
				} else {
					// If there is a template, I'll show it
					return this.templateRender();
				}
			},
			watch: {
				template: {
					immediate: true, // makes the watcher fire on first render, too.
					handler() {
						let renderText = '';
						if (this.text.indexOf('<') !== 0) renderText = '<p>' + this.text + '</p>';
						else renderText = this.text;
						var res = Vue.compile(renderText);
						this.templateRender = res.render;
						this.$options.staticRenderFns = [];
						this._staticTrees = [];
						for (var i in res.staticRenderFns) {
							this.$options.staticRenderFns.push(res.staticRenderFns[i]);
						}
					},
				},
			},
		});
		Vue.directive('numberonly', {
			bind(el) {
				el.addEventListener('keydown', e => {
					if (
						[46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
						// Allow: Ctrl+A
						(e.keyCode === 65 && e.ctrlKey === true) ||
						// Allow: Ctrl+C
						(e.keyCode === 67 && e.ctrlKey === true) ||
						// Allow: Ctrl+X
						(e.keyCode === 88 && e.ctrlKey === true) ||
						// Allow: home, end, left, right
						(e.keyCode >= 35 && e.keyCode <= 39)
					) {
						// let it happen, don't do anything
						return;
					}
					// Ensure that it is a number and stop the keypress
					if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
						e.preventDefault();
					}
				});
			},
		});
		Vue.filter('timeOnly', function(value) {
			if (value) {
				return new Date(value).format('HH:mm a/p');
			}
		});
		Vue.filter('dateStr', function(value) {
			if (value) {
				return value.substr(0, 4) + '.' + value.substr(4, 2) + '.' + value.substr(6, 2);
			}
		});
		Vue.filter('dateStrNo', function(value) {
			if (value) {
				return value.substr(0, 4) + '-' + value.substr(4, 2) + '-' + value.substr(6, 2);
			}
		});
		Vue.filter('canCourier', function(value) {
			if (value) {
				let v = value.substring(0, 2);
				let v2 = value.substring(0, 3);
				return !(
					v === 'S7' ||
					v === 'ZP' ||
					(v === 'ZK' && v2 !== 'ZK0' && v2 !== 'ZK1' && v2 !== 'ZK2') ||
					v === 'Z2' ||
					v === 'Z3' ||
					v === 'Z6' ||
					v === 'ZX' ||
					v === 'ZO' ||
					v === 'ZQ' ||
					v === 'ZT' ||
					v === 'ZY'
				);
			}
			return false;
		});
		Vue.filter('progressStateByCode', function(value) {
			if (value) {
				if (value === 'C1400' || value === 'C1410' || value === 'C1414' || value === 'C1415') {
					// 이미지 검사, 자동접수, 미접수, 접수보류
					return '미접수';
				} else if (value === 'C1412') {
					return '업로드 대기중';
				} else if (value === 'C14D0' || value === 'C14D1') {
					// 주문취소, 주문오류
					return '접수취소';
				} else if (value === 'C14E0' || value === 'C14E1') {
					// 오류처리, 오류처리(선입)
					return '오류처리';
				} else if (value === 'C14S0') {
					return '매출취소';
				} else if (value === 'C1416') {
					return '접수중';
				} else if (value === 'C1419' || value === 'C1420' || value === 'C1421') {
					// 접수완료, 입금대기, 조판대기
					// 상태에 따라 : 입금대기
					return '정상접수';
				} else if (value === 'C1422' || value === 'C1425' || value === 'C1428') {
					// 조판중, 조판작업중, 이월처리
					return '조판중';
				} else if (value === 'C1429' || value === 'C1430' || value === 'C1431') {
					// 조판완료, 조판일부완료, 인쇄중
					// 상태에따라: 시안생성, 시안확인,
					return '인쇄중';
				} else if (value === 'C1432') {
					return '인쇄완료';
				} else if (value === 'C1439') {
					return '후가공중';
				} else if (value === 'C1438') {
					return '후가공완료';
				} else if (value === 'C1440') {
					return '재단완료';
				} else if (value === 'C1442' || value === 'C1449') {
					// 센터입고관료, 입고완료
					return '입고완료';
				} else if (value === 'C1441' || value === 'C1443') {
					// 센터입고중, 선터이동중
					return '센터입고중';
				} else if (value === 'C1450' || value === 'C1451') {
					// 출고완료, 센터출고완료
					// 상태에따라: 발송완료
					return '출고완료';
				}
			}
			return '';
		});
		Vue.filter('aspXss', function(value) {
			if (value) {
				value = value.replace(/&quot;/g, '"');
				value = value.replace(/&lt;/g, '<');
				value = value.replace(/&gt;/g, '>');
				value = value.replace(/&nbsp;/g, ' ');
				return value;
			}
		});
		Vue.filter('decodeHtml', function(value) {
			let txt = document.createElement('textarea');
			txt.innerHTML = value;
			return txt.value;
		});
		Vue.filter('changeImageUrl', function(value) {
			if (value) value = value.replace(/\/imgs\//g, CONST.WEB_SERVER + '/imgs/');
			if (value) value = value.replace(/\/images\//g, CONST.WEB_SERVER + '/images/');
			return value;
		});
		Vue.filter('currency', function(value) {
			if (value) {
				return numeral(value).format(0, 0);
			}
			return value;
		});
		Vue.filter('numberOnly', function(value) {
			let m = value.match(/[^0-9]/gi);
			if (m) {
				return ('' + value).replace(/[^0-9]/gi, '');
			} else {
				return value;
			}
		});
		Vue.filter('phoneNumberOnly', function(value) {
			value.replace(/[^0-9]/gi, '');
			let formatNum = value
				.replace(/[^0-9]/g, '')
				// .replace(/(^[0-9]{3})([0-9]{4})?([0-9]+)$/, '$1-$2-$3')
				.replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
				.replace('--', '-');
			return formatNum;
		});
		Vue.filter('moneyOnly', function(value) {
			value.replace(/[^0-9]/gi, '');
			let formatNum = value.replace(/[^0-9]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			return formatNum;
		});
		Vue.filter('registrationNoOnly', function(value) {
			if (value != null && value != '') {
				value.replace(/[^0-9]/gi, '');
				let formatNum = value.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
				return formatNum;
			} else {
				return;
			}
		});
		Vue.filter('corporationNumberOnly', function(value) {
			value.replace(/[^0-9]/gi, '');
			let formatNum = value.replace(/[^0-9]/g, '').replace(/(\d{6})(\d{7})/, '$1-$2');
			return formatNum;
		});
		Vue.filter('messageTime', function(value) {
			if (value) {
				if (new Date(value).format('yyyyMMdd') === new Date().format('yyyyMMdd')) return new Date(value).format('HH:mm a/p');
				else return new Date(value).format('MM월 dd일');
			}
		});
		Vue.filter('messageDetailTime', function(value) {
			if (value) {
				if (new Date(value).format('yyyyMMdd') === new Date().format('yyyyMMdd')) return new Date(value).format('HH:mm a/p');
				else return new Date(value).format('MM월 dd일 HH:mm a/p');
			}
		});
		Vue.filter('stripHtml', function(value, ingTags) {
			if (value) {
				let tags = ['br', 'img', 'p'];
				if (ingTags) tags = tags.concat(ingTags);
				return stripHtml(value, {
					ignoreTags: tags,
					stripTogetherWithTheirContents: ['script', 'style', 'xml'],
				});
			}
			return value;
		});
		Vue.filter('stripHtmlAll', function(value, ingTags) {
			if (value) {
				let tags = [];
				if (ingTags) tags = tags.concat(ingTags);
				return stripHtml(value, {
					ignoreTags: tags,
					stripTogetherWithTheirContents: ['script', 'style', 'xml'],
				});
			}
			return value;
		});
		Vue.filter('newLine', function(value) {
			return value ? value.replace(/(?:\r\n|\r|\n)/g, '<br />') : '';
		});
		Vue.filter('productTag', function(value) {
			if (value) {
				// new, hit, sale, diy, white, free_delivery
				// new hit sale free
				let n = value.toLocaleLowerCase();
				if (n.indexOf('new') > -1) {
					return 'new';
				} else if (n.indexOf('hit') > -1) {
					return 'hit';
				} else if (n.indexOf('sale') > -1) {
					return 'sale';
				} else if (n.indexOf('free_delivery') > -1) {
					return 'free';
				}
			}
			return '';
		});
		Vue.filter('productMainImage', function(value) {
			if (value) {
				for (let i = 0; i < CONST.PRODUCT_IMAGES.length; i++) {
					if (CONST.PRODUCT_IMAGES[i].code === value) {
						return CONST.PRODUCT_IMAGES[i];
					}
				}
			}
			return '';
		});
		Vue.filter('myunGb', function(value) {
			if (value) {
				let sVal = '' + value;
				if (sVal === '0') {
					return 'S';
				} else if (sVal === 'X') {
					return 'X';
				} else if (sVal === '1') {
					return 'S';
				} else if (sVal === '2') {
					return 'S';
				} else if (sVal === '4') {
					return 'S';
				} else if (sVal >= '5') {
					return 'D';
				}
			}
			return '';
		});
		Vue.filter('myunGbJudanD', function(value) {
			if (value) {
				value = '' + value;
				if (value === '0') {
					return 'X';
				} else if (value === 'X') {
					return 'X';
				} else if (value === '1') {
					return 'S';
				} else if (value === '2') {
					return 'D';
				} else if (value === '2_1') {
					return 'S';
				} else if (value === '4') {
					return 'S';
				} else if (Number(value || 0) >= 5) {
					return 'D';
				}
			}
			return '';
		});
		Vue.filter('autolink', function(value) {
			if (value && value !== '') {
				var autolinker = new AutoLinker({
					urls: {
						schemeMatches: true,
						wwwMatches: true,
						tldMatches: true,
					},
					email: true,
					phone: true,
					mention: false,
					hashtag: false,
					stripPrefix: true,
					stripTrailingSlash: true,
					newWindow: true,
					truncate: {
						length: 0,
						location: 'end',
					},
					className: '',
					replaceFn: function(match) {
						//console.log("href = ", match.getAnchorHref());
						//console.log("text = ", match.getAnchorText());
						switch (match.getType()) {
							case 'url':
								//console.log("url: ", match.getUrl());
								return (
									'<nav-link v-bind:url="\'' +
									match.getUrl() +
									'\'" v-bind:open-url="true" v-bind:external-url="true">' +
									match.getAnchorText() +
									'</nav-link>'
								);
							case 'email':
								//var email = match.getEmail();
								//console.log("email: ", email);
								return (
									'<nav-link v-bind:url="\'mailto:' +
									match.getEmail() +
									'\'" v-bind:open-url="true" v-bind:external-url="true">' +
									match.getAnchorText() +
									'</nav-link>'
								);
							case 'phone':
								//console.log("Phone Number: ", match.getPhoneNumber());
								return (
									'<nav-link v-bind:url="\'tel:' +
									match.getEmail() +
									'\'" v-bind:open-url="true" v-bind:external-url="true">' +
									match.getAnchorText() +
									'</nav-link>'
								);
							//case 'mention' :
							//    console.log("Mention: ", match.getMention());
							//    console.log("Mention Service Name: ", match.getServiceName());
							//    return false;
							//case 'hashtag' :
							//    console.log("Hashtag: ", match.getHashtag());
							//    return false;
							default:
								return false;
						}
					},
				});
				return autolinker.link(value);
			}
			return '<span></span>';
		});
		Vue.mixin({
			created: function() {},
			mounted: function() {},
			beforeDestroy: function() {},
		});
		Vue.prototype.$device = {
			compress: function(s) {
				return typeof s !== 'undefined' && s !== null && s !== '' ? lzString.compressToUTF16(s) : '';
			},
			decompress: function(s) {
				return typeof s !== 'undefined' && s !== null && s !== '' ? lzString.decompressFromUTF16(s) : '';
			},
			randCode(len) {
				let text = '';
				let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
				for (let i = 0; i < len; i++) {
					text += chars.charAt(Math.floor(Math.random() * chars.length));
				}
				return text;
			},
			checkNull(str) {
				return str && str.trim() !== '';
			},
			randNumber(min, max) {
				let ranNum = Math.floor(Math.random() * (max - min + 1)) + min;
				return ranNum;
			},
			getUUID() {
				let dt = new Date().getTime();
				let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
					var r = (dt + Math.random() * 16) % 16 | 0;
					dt = Math.floor(dt / 16);
					return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
				});
				return uuid;
			},
			versionCompare: function(myVersion, minimumVersion) {
				let v1 = myVersion.split('.'),
					v2 = minimumVersion.split('.'),
					minLength;
				minLength = Math.min(v1.length, v2.length);
				for (let i = 0; i < minLength; i++) {
					if (Number(v1[i]) > Number(v2[i])) {
						return true;
					}
					if (Number(v1[i]) < Number(v2[i])) {
						return false;
					}
				}
				return v1.length >= v2.length;
			},
			maskEmail(str) {
				let originStr = str;
				let emailStr = originStr.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
				let strLength;
				if (this.checkNull(originStr) || this.checkNull(emailStr)) {
					return originStr;
				} else {
					strLength = emailStr.toString().split('@')[0].length - 3;
					// ex1) abcdefg12345@naver.com => ab**********@naver.com
					// return originStr.toString().replace(new RegExp('.(?=.{0,' + strLength + '}@)', 'g'), '*');
					// ex2) abcdefg12345@naver.com => ab**********@nav******
					return originStr
						.toString()
						.replace(new RegExp('.(?=.{0,' + strLength + '}@)', 'g'), '*')
						.replace(/.{6}$/, '******');
				}
			},
			verifyEmail: function(email) {
				let regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
				if (email.match(regExp) != null) {
					return true;
				}
				return false;
			},
			isMobile() {
				return /iPhone|iPod|iPad|android/i.test(navigator.platform);
			},
			isIos() {
				return /iPhone|iPod|iPad/i.test(navigator.platform);
			},
			isAndroid() {
				return /(android)/i.test(navigator.userAgent);
			},
			getTotalLocalData: function() {
				let allStrings = '';
				for (let key in window.localStorage) {
					//eslint-disable-next-line no-prototype-builtins
					if (window.localStorage.hasOwnProperty(key)) {
						allStrings += window.localStorage[key];
					}
				}
				return allStrings ? (3 + (allStrings.length * 16) / (8 * 1024)).format() + ' KB' : 'Empty (0 KB)';
			},
			saveLocalData: function(key, val) {
				let storage = window.localStorage;
				if (storage) {
					try {
						storage.setItem(key, lzString.compressToUTF16(val));
					} catch (e) {
						console.error('Storage Full ... clean old data...');
						for (let k in storage) {
							console.log(k);
							if (k.indexOf('DATA_MESSAGE_DETAIL_') > -1) {
								storage.removeItem(k);
							}
						}
						storage.setItem(key, lzString.compressToUTF16(val));
					}
				}
			},
			loadLocalData: function(key) {
				let storage = window.localStorage;
				if (storage) {
					return lzString.decompressFromUTF16(storage.getItem(key));
				}
				return '';
			},
			removeLocalData: function(key) {
				let storage = window.localStorage;
				if (storage) {
					storage.removeItem(key);
				}
			},
			clearLocalData: function() {
				let storage = window.localStorage;
				if (storage) {
					//storage.clear();
					for (let k in storage) {
						//console.log(k);
						if (k.indexOf('AUTOLOGIN_') < 0) {
							storage.removeItem(k);
						}
					}
				}
			},
			pushView: function(url, isExternal) {
				if (typeof url === 'undefined' || ('' + url).trim() === '') {
					window.alert('주소를 찾을 수 없습니다.');
					return;
				}
				if (!isExternal && url.indexOf('http') < 0) {
					let getUrl = window.location;
					let baseUrl = getUrl.protocol + '//' + getUrl.host + getUrl.pathname;
					url = baseUrl + '#' + url;
				}
				if (window.dtpiaApp && window.dtpiaApp.pushView) {
					window.dtpiaApp.pushView(url);
				} else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.pushView) {
					window.webkit.messageHandlers.pushView.postMessage(url);
				} else {
					window.location.href = url;
				}
			},
			popView: function(url) {
				if (window.dtpiaApp && window.dtpiaApp.popView) {
					window.dtpiaApp.popView();
				} else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.popView) {
					window.webkit.messageHandlers.popView.postMessage(1);
				} else {
					if (typeof url === 'undefined' || url === '') window.history.go(-1);
					else window.location.href = url;
				}
			},
			openUrl: function(url, isExternal) {
				if (typeof url === 'undefined' || url === null || url === '') {
					window.alert('호출 주소가 없습니다.');
					return;
				}
				if (!isExternal && url.indexOf('http') < 0) {
					let getUrl = window.location;
					let baseUrl = getUrl.protocol + '//' + getUrl.host + getUrl.pathname;
					url = baseUrl + '#' + url;
				}
				if (window.dtpiaApp && window.dtpiaApp.openUrl) {
					window.dtpiaApp.openUrl(url);
				} else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openUrl) {
					window.webkit.messageHandlers.openUrl.postMessage(url);
				} else {
					window.open(url, '_blank');
				}
			},
			setHeaderTitle: function(title) {
				eventBus.$emit('SET_HEADER_TITLE', title);
				//eventBus.$emit('IS_HEADER_MAIN', false);
				if (window.dtpiaApp && window.dtpiaApp.setHeaderTitle) {
					window.dtpiaApp.setHeaderTitle(title);
				} else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.setHeaderTitle) {
					window.webkit.messageHandlers.setHeaderTitle.postMessage(JSON.stringify({ title: title }));
				}
			},
			setHeaderState: function(b) {
				eventBus.$emit('SET_HEADER_STATE', b);
				if (window.dtpiaApp && window.dtpiaApp.isHeaderMain) {
					window.dtpiaApp.isHeaderMain(b);
				} else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.isHeaderMain) {
					window.webkit.messageHandlers.isHeaderMain.postMessage(b);
				}
			},
			hideFooterMenu: function(b, m, e) {
				eventBus.$emit('HIDE_FOOTER_MENU', b, m, e);
				if (window.dtpiaApp && window.dtpiaApp.hideFooterMenu) {
					window.dtpiaApp.hideFooterMenu(b, m, e);
				} else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.hideFooterMenu) {
					window.webkit.messageHandlers.hideFooterMenu.postMessage(b, m, e);
				}
			},
			openSideMenu: function() {
				eventBus.$emit(CONST.EVENTS.OPEN_SIDE_MENU);
			},
			closeSideMenu: function() {
				eventBus.$emit(CONST.EVENTS.CLOSE_SIDE_MENU);
			},
			hasPopup: function(v) {
				eventBus.$emit(CONST.EVENTS.HAS_POPUP, v);
			},
			sendEvent: function(t, v) {
				eventBus.$emit(t, v);
			},
			loadMemberInfo: function() {
				try {
					let dt = this.$device.loadLocalData('LOGIN_USER');
					if (dt) {
						this.loginMember = JSON.parse(dt);
						this.$apiClient.setApiToken(this.loginMember.loginToken);
					} else {
						this.loginMember = null;
						this.$device.pushView('/login');
					}
				} catch (e) {
					console.error(e);
				}
			},
			isEmpty: function(v) {
				return v === null || v === '' || typeof v === 'undefined';
			},
			getProgramReportTitle: function(v) {
				let title = '보고서';
				switch (v) {
					case 'P01':
						title = '타당성 및 시장조사';
						break;
					case 'P02':
						title = '바이어 미팅';
						break;
					case 'P03':
						title = '해외인증';
						break;
					case 'P04':
						title = '샘플발송';
						break;
					case 'P05':
						title = '기술지원';
						break;
					case 'P06':
						title = '유통채널 입점대행';
						break;
					case 'P07':
						title = '전시회 대행';
						break;
					case 'P08':
						title = '홍보물 제작';
						break;
					case 'P09':
						title = '통∙번역';
						break;
					case 'P10':
						title = '기타1';
						break;
					case 'P11':
						title = '기타2';
						break;
					case 'P12':
						title = '기타3';
						break;
					case 'P13':
						title = '기타4';
						break;
					default:
						title = '보고서';
						break;
				}
				return title;
			},
		};
		let OktaMobile = function($v) {
			this.vue = $v;
		};
		OktaMobile.prototype.onStart = function() {
			eventBus.$emit('VIEW_ON_START');
			console.log('onStart VIEW_ON_START');
		};
		OktaMobile.prototype.onPause = function() {
			eventBus.$emit('VIEW_ON_PAUSE');
			console.log('onPause VIEW_ON_PAUSE');
		};
		window.oktaMobile = new OktaMobile(Vue);
	},
};
